'use client'

import { useRouter } from 'next/navigation'

import { useSearchFilterStore } from '@/entities/map'
import {
  AutoCompleteInput,
  PeriodPicker,
  useSearch,
} from '@/features/room-filter'
import { Button } from '@/shared/ui'

export const SearchGroup = () => {
  const router = useRouter()
  const filterActions = useSearchFilterStore(state => state.actions)

  const search: Parameters<typeof useSearch>[0]['search'] = params => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value) {
        searchParams.set(key, String(value))
      }
    })

    const { startDate, endDate, keyword } = params

    filterActions.updateKeyword(keyword)
    filterActions.update({ startDate, endDate })
    router.push(`/guest/search?${searchParams.toString()}`)
  }

  const { autoCompleteInputProps, periodPickerProps, handleSubmit } = useSearch(
    { search },
  )

  return (
    <div className="gradient-border shrink-0 shadow-[0px_-3px_7px_0px_rgba(0,0,0,0.05),0px_0px_7px_0px_rgba(0,0,0,0.05),0px_5px_6px_0px_rgba(0,0,0,0.11)]">
      <div className="flex h-[60px] w-[670px] items-center pr-4">
        <div className="flex">
          <AutoCompleteInput
            className="mr-1 w-[320px] shrink-0 pl-[5px]"
            inputClassName="bg-[rgba(0,0,0,0)] border-none w-full text-[15px]! leading-[22px]! h-[50px] *:placeholder:text-gray-400"
            placeholder="지역, 지하철, 대학교 등을 입력해 주세요"
            popupAlign="end"
            popupSideOffset={7}
            popupAlignOffset={-350}
            {...autoCompleteInputProps}
          />
          <PeriodPicker
            className="mr-5 -ml-[5px] h-[50px] w-[266px] shrink-0 focus-visible:outline-none"
            placeholder="일정을 선택해 주세요"
            align="end"
            sideOffset={7}
            alignOffset={-92}
            {...periodPickerProps}
          />
        </div>
        <Button
          size="small"
          weight="normal"
          className="w-[50px] flex-shrink-0"
          onClick={handleSubmit}
        >
          검색
        </Button>
      </div>
    </div>
  )
}
